export default function isObjectEmpty(obj) {
    var k;
    for (k in obj) {
        // even if its not own property I'd still call it non-empty
        return false;
    }
    return true;
}



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/is-object-empty.js
// module id = 811
// module chunks = 113